export default [
  {
    path: '*',
    meta: {
      public: true
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true
    },
    name: '404',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/404.vue`
    )
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Home.vue`
    )
  },
  {
    path: '/certificate/:pb_key',
    name: 'Certificate',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Certificate.vue`
    )
  }
]
